var waitFor = require("../utils/waitFor");
// var selecter = require('../lib/slick');
var colHeightEq = require("../utils/colHeightEq");

waitFor(".landing-intranet", function () {
  // add slick
  $(".intra-slider").slick({
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1200,
  });

  colHeightEq();
});
